import AddEventTimesCellHtml     from './templates/add.event.times.cell.html';
import CurrencyCellHtml          from '../../app-lite/grids/templates/cell.currency.html';
import CustomerSearchResultsHtml from '../../app-lite/customers/templates/customers.search.results.html';
import DynamicColorRowHtml       from '../../app-lite/grids/templates/row.dynamic-color.html';
import EditableCellHtml          from '../../app-lite/grids/templates/cell.editable.html';
import EditableCurrencyCellHtml  from '../../app-lite/grids/templates/cell.currency.editable.html';
import EditableNumberCellHtml    from '../../app-lite/grids/templates/cell.number.editable.html';
import EventFooterHtml           from './templates/event.footer.html';
import NumberCellHtml            from '../../app-lite/grids/templates/cell.number.html';
import ProductSearchCellHtml     from '../../app-lite/products/templates/product-search.cell.html';
import RemoveRowCellHtml         from '../../app-lite/grids/templates/cell.remove-row.html';

export function EventCtrl (
  $filter,
  $q,
  $scope,
  $state,
  $stateParams,
  $translate,
  $window,
  API,
  AshdownEvents,
  bursonApi,
  confirm,
  customer,
  dateParsing,
  defaultLaborItem,
  defaultTaxGroup,
  event,
  Event,
  gridAPI,
  gsfApi,
  haynesProApi,
  HsyItems,
  inspections,
  invoices,
  jobStatusTypes,
  LoanCarEvents,
  messages,
  messengerApi,
  OscarEvents,
  partstechApi,
  productApi,
  productSearchApi,
  PROLinkEvents,
  sessionObjAPI,
  streamSearch,
  taxGroups,
  templatedWording,
  tireconnectApi,
  vehicle,
  vehicleApi,
  VVGarage,
  windowApi,
  workshopAPI
) {
  $scope.customerSearchResultsTemplateUrl = CustomerSearchResultsHtml;
  $scope.eventFooterTemplateUrl           = EventFooterHtml;

  $scope.currency       = sessionObjAPI.currency();
  $scope.company        = sessionObjAPI.company();
  $scope.inspections    = inspections;
  $scope.jobStatusTypes = jobStatusTypes;
  $scope.loaded         = true;
  $scope.session        = sessionObjAPI.base();
  $scope.invoices       = invoices;
  $scope.dateFormat     = sessionObjAPI.company().country_code === 'usa' ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
  $scope.taxGroups      = taxGroups;

  $scope.customer = customer || {
    cash_or_account: 'C',
    customer_type  : 'I',
    id             : '',
    price_type     : '1'
  };

  $scope.vehicle = vehicle || {
    air_con     : true,
    automatic   : true,
    body_type   : 'SEDAN',
    customer_id : $scope.customer.id,
    transmission: 'N/A'
  };

  $scope.event = event || {
    customer_id           : $scope.customer.id,
    discount              : 0.00,
    discount_type         : 'C',
    event_date            : $stateParams.date || dateParsing.today(),
    event_items_attributes: [],
    gst                   : 0.00,
    id                    : null,
    itemsToDelete         : [],
    rounding              : '0.00',
    savedBalance          : '0',
    savedTotal            : '0',
    subtotal              : 0.00,
    tax_free              : $scope.customer.tax_free,
    total                 : 0.00,
    vehicle_id            : $scope.vehicle.id || ''
  };

  $scope.event.vehicle_id = $scope.vehicle.id || '';

  $scope.originalDiscount = $scope.event.discount;

  $scope.Event     = new Event($scope.event, $scope.taxGroups);
  $scope.VVGarage  = new VVGarage($scope.customer);

  if ($scope.event.id) {
    if ($scope.event.loan_car_id) {
      workshopAPI.get('/loan_car', $scope.event.loan_car_id).then(function (data) {
        $scope.loan_car = data;
        $scope.LoanCarEvents = new LoanCarEvents($scope.loan_car, $scope.Event.event, $scope.customer);
      });
    }
    else {
      $scope.loan_car = [];
      $scope.LoanCarEvents = new LoanCarEvents($scope.loan_car, $scope.Event.event, $scope.customer);
    }
  };

  $scope.filterTaxGroup = function (id) {
    $scope.event.tax_group = $scope.taxGroups.filter(function (group) {
      return group.id === id;
    })[0];
  };

  if ($scope.company.use_multi_tax && $scope.taxGroups.length && !$scope.event.tax_group_id) {
    $scope.event.tax_group_id = defaultTaxGroup ? defaultTaxGroup.id: ($scope.company.tax_group_id || $scope.taxGroups[0].id);
    $scope.filterTaxGroup($scope.event.tax_group_id);
  }
  else if (($scope.company.use_multi_tax || $scope.Event.closed()) && $scope.event.tax_group_id) {
    $scope.event.tax_group = {
      tax_group_items_attributes: $scope.event.event_tax_items_attributes
    };
  }
  else if (!$scope.company.use_multi_tax) {
    $scope.event.tax_group_id = null;
  }

  $scope.Ashdown     = new AshdownEvents($scope.Event, $scope.vehicle);
  $scope.HsyItems    = new HsyItems($scope.customer, $scope.vehicle, 'event');
  $scope.OscarEvents = new OscarEvents($scope.Event, $scope.vehicle);
  $scope.PROLink     = new PROLinkEvents($scope.Event, $scope.vehicle);

  $scope.addPartstechLabor = function () {
    $q.when()
    .then(() => {
      return $scope.Event.form.$dirty || !$scope.event.id
        ? confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.BOOKING_MUST_FIRST_BE_SAVED', {
            name: $translate.instant('PARTSTECH_SPACE.PARTSTECH_LABOUR')
          }), null, 'partstechLaborEventAutoSave')
          .then(() => $scope.Event.save())
        : $q.when($scope.event);
    })
    .then(event => partstechApi.addLabor({
      id  : event.id,
      type: 'event'
    }, $scope.vehicle))
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $state.reload();
    });
  };

  $scope.createLoan = function () {
    $scope.LoanCarEvents.createLoan().then(function () {
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.startLoan = function () {
    $scope.LoanCarEvents.startLoan().then(function () {
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.returnLoan = function () {
    $scope.LoanCarEvents.returnLoan().then(function () {
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.reviewLoan = function () {
    $scope.LoanCarEvents.reviewLoan().then(function () {
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.cancelDiscount = function () {
    $scope.event.discount = $scope.originalDiscount;

    $scope.toggleDiscount();
  };

  $scope.confirmDiscount = function () {
    if ( $scope.Event.form.discount.$valid ) {
      $scope.originalDiscount = $scope.event.discount;

      $scope.calculateTotals();
      $scope.toggleDiscount();
    }
  };

  $scope.toggleDiscount = function () {
    $scope.showDiscount = !$scope.showDiscount;
  };

  $scope.createInspection = function () {
    workshopAPI.get('/event/create_inspection', $scope.event.id).then(function (data) {
      $state.go('app.inspection', {
        customer_id: data.customer_id,
        vehicle_id : data.vehicle_id,
        id         : data.id
      });
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.customerSelected = function (customer) {
    $state.go('app.event', {
      customer_id: customer.id,
      date       : $scope.event.event_date
    });
  };

  $scope.selectVehicle = function (vehicle) {
    $state.go('app.event', {
      customer_id: $scope.customer.id,
      vehicle_id : vehicle.id,
      date       : $scope.event.event_date,
      id         : $scope.event.id
    });
  };

  $scope.grid = {
    data                   : 'event.event_items_attributes',
    cellEditableCondition  : '!Event.closed()',
    enableCellSelection    : true,
    enableRowSelection     : false,
    enableCellEditOnFocus  : true,
    enableSorting          : false,
    rowHeight              : 43,
    virtualizationThreshold: 9999,
    rowTemplate            : DynamicColorRowHtml,
    columnDefs             : [
      {
        displayName   : '',
        enableCellEdit: false,
        cellTemplate  : RemoveRowCellHtml,
        disabled      : $scope.Event.closed(),
        width         : '43px'
      },
      {
        field               : 'item_code',
        displayName         : $translate.instant('PRODUCT_SPACE.PRODUCT') ,
        editableCellTemplate: ProductSearchCellHtml,
      },
      {
        displayName   : '',
        enableCellEdit: false,
        cellTemplate  : AddEventTimesCellHtml,
        width         : '43px'
      },
      {
        field                : 'description',
        displayName          : $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION') ,
        editableCellTemplate : EditableCellHtml,
        cellEditableCondition: '!Event.closed() && row.entity.product_id'
      },
      {
        field                : 'unit_price',
        displayName          : $translate.instant('JS_SPACE.COLUMNS.UNIT_PRICE') ,
        min                  : -99999,
        cellFilter           : 'globalCurrency',
        cellClass            : 'text-right',
        width                : '101px',
        editableCellTemplate : EditableCurrencyCellHtml,
        cellTemplate         : CurrencyCellHtml,
        cellEditableCondition: '!Event.closed() && !row.entity.is_bom_parent && row.entity.product_id'
      },
      {
        field                : 'quantity',
        displayName          : $translate.instant('PRODUCT_SPACE.QTY') ,
        cellClass            : 'text-right',
        width                : '61px',
        editableCellTemplate : EditableNumberCellHtml,
        cellTemplate         : NumberCellHtml,
        cellEditableCondition: '!Event.closed() && !row.entity.is_bom_parent && row.entity.product_id'
      },
      {
        field         : 'getTotal()',
        displayName   : $translate.instant('INVOICE_SPACE.LINE_TOTAL') ,
        visible       : !($window.innerWidth <= 1200),
        cellFilter    : 'globalCurrency',
        cellTemplate  : CurrencyCellHtml,
        enableCellEdit: false,
        width         : '101px',
        cellClass     : 'text-right ReadOnly'
      },
    ]
  };

  if ($scope.Company.isFlatRateEnabled()) {
    $scope.grid.columnDefs.splice($scope.grid.columnDefs.length-3, 0, {
        field                : 'flat_rate',
        cellClass            : 'text-right',
        cellEditableCondition: 'isFlatRateEditable(row.entity)',
        cellTemplate         : NumberCellHtml,
        displayName          : $translate.instant('GENERAL_SPACE.FIELD.FLAT_RATE'),
        editableCellTemplate : EditableNumberCellHtml,
        min                  : 0,
        max                  : () => parseFloat(999999),
        width                : '110px'
      });
    }

  if (!$scope.company.use_multi_tax) {
    $scope.grid.columnDefs.splice($scope.grid.columnDefs.length-1, 0, {
      field         : 'getTax()',
      displayName   : $scope.currency.tax_name,
      visible       : !($window.innerWidth <= 1200),
      cellFilter    : 'globalCurrency',
      cellTemplate  : CurrencyCellHtml,
      enableCellEdit: false,
      width         : '93px',
      cellClass     : 'align-right ReadOnly'
    });
  }

  $scope.addCalcFunctions = function() {
    angular.forEach($scope.event.event_items_attributes, function (item, idx) {
      item.getTotal = function () {
        return $scope.Event.totals.itemTotals.total(item);
      };
      item.getTax = function () {
        return $scope.Event.totals.itemTotals.tax(item);
      };

      item.ordering = item.ordering && item.ordering === 0 ? item.ordering: idx * 1000000;
    });
  };

  $scope.setFlagsAndFunctions = function() {
    let hasGroupTax = false;

    angular.forEach($scope.event.event_items_attributes, function (item, idx) {

      if (!$scope.Event.event.repco && item.repco_sku) {
        $scope.Event.event.repco = true;
      }

      if (!$scope.Event.event.ashdown && $scope.Ashdown.hasSku(item)) {
        $scope.Event.event.ashdown = true;
      }

      if (!$scope.Event.event.prolink && $scope.PROLink.hasSku(item)) {
        $scope.Event.event.prolink = true;
      }

      item.getTotal = function () {
        return $scope.Event.totals.itemTotals.total(item);
      };

      item.getTax = function () {
        return $scope.Event.totals.itemTotals.tax(item);
      };

      item.ordering = item.ordering && item.ordering === 0 ? item.ordering: idx * 1000000;

      hasGroupTax = hasGroupTax || ( item.sales_tax_rate && item.sales_tax_rate !== $scope.company.sales_tax_rate );
    });

    $scope.Event.totals.hasGroupTax = hasGroupTax;

    if ( hasGroupTax ) {
      $scope.initDiscount();
    }
  };

  $scope.prepInvoice = function () {
    $scope.event.itemsToDelete = [];
    $scope.savedTotal          = $scope.event.total;
    $scope.savedBalance        = $scope.event.balance_due;
    $scope.event.tax_free      = $scope.customer.tax_free;
    $scope.event.discount_type = $scope.event.discount_type || 'C';

    if ($scope.event.event_items_attributes.length) {
      $scope.setFlagsAndFunctions();
    }
    else {
      $scope.addItem();
    }

    $scope.calculateTotals();
  };

  $scope.addFromGsf = function () {
    confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.EVENT_MUST_FIRST_BE_SAVED', {
      name: $translate.instant('COMPANY_SPACE.INTEGRATIONS.GSF.GSF')
    }), null, 'gsfEventAutoSave')
    .then(() => $scope.Event.save())
    .then(event => gsfApi.getPortalUrl('event', $scope.vehicle, event.id))
    .then(url => {
      windowApi.open(url, '_blank')
      .then(isVisible => {

        $state.reload();
      });
    })
    .catch(err => {
      if ( err ) {
        messages.error(err);
      }
    });
  };

  $scope.addItemsFromBurson = function () {
    $scope.disableBurson = true;

    $q.when()
    .then(() => $scope.event.id ? $q.when() : confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.EVENT_MUST_FIRST_BE_SAVED', { name: 'Burson EzyParts' }), null, 'bursonEventAutoSave'))
    .then(() => $scope.Event.save())
    .then(event => bursonApi.getUrl('event', event))
    .then(url => $window.location.assign(url))
    .catch(err => {
      messages.error(err);
    }).finally(() => {
      $state.reload();
      $scope.disableBurson = false;
    });
  };

  $scope.addItemsFromHsy = function () {
    $q.when().then(() => {
      return $scope.event.id ? $q.when() : confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.EVENT_MUST_FIRST_BE_SAVED', { name: 'HSY' }), null, 'hsyEventAutoSave');
    }).then(() => {
      return $scope.event.id ? $q.when($scope.event) : $scope.Event.save();
    }).then(event => {
      return $scope.HsyItems.getPortalUrl(event);
    }).then(url => {
      $window.location.assign(url);
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.addItemsFromOscar = function () {
    $scope.disableOscar = true;

    $scope.OscarEvents.addItems().then(result => {
      messages.show(result, 'success');
    }).catch(err => {
      messages.error(err);
    }).finally(() => {
      $state.reload();
      $scope.disableOscar = false;
    });
  };

  $scope.addItemsFromTireconnect = function () {
    $q.when()
    .then(() => {
      return $scope.event.id ?
        $q.when($scope.Event.event) :
        confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.EVENT_MUST_FIRST_BE_SAVED', {
          name: 'Tireconnect'
        }), null, 'tireconnectEventsAutoSave')
        .then(() => $scope.Event.save());
    })
    .then(event => tireconnectApi.getPortalUrl($scope.vehicle, event.id, 'event'))
    .then(url => {
      const newWindow = $window.open(url, '_blank');

      newWindow.onbeforeunload = function () {
        sessionObjAPI.removeKey(tireconnectApi.storageKey);

        $state.reload();
      };
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.addLaborFromHaynesPro = function () {
    let savedEvent;

    confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', {
      name: haynesProApi.lookupsTitle
    }), null, 'haynesProEventAutoSave')
    .then(() => $scope.Event.save())
    .then(event => {
      savedEvent = event;

      return vehicleApi.get($scope.vehicle.id);
    })
    .then(vehicle => {
      $scope.vehicle = vehicle;

      return haynesProApi.addLaborTimes($scope.vehicle, savedEvent.id, 'event');
    })
    .then(() => {
      messages.show($translate.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.LABOUR_TIMES_ADDED'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.calculateTotals = function () {
    $scope.event.subtotal             = $scope.Event.totals.subtotal({discount: true});
    $scope.event.gst                  = $scope.Event.totals.tax();
    $scope.event.total                = $scope.Event.totals.total();
    $scope.event.balance_due          = $scope.Event.totals.balance();
    $scope.event.rounding             = $scope.Event.totals.rounding();
    $scope.event.discount_on_subtotal = $scope.Event.totals.subtotalDiscount();
    $scope.event.discount_total       = $scope.Event.totals.totalDiscount();
  };

  $scope.mechanicSearch = {
    list: [],
    search (typed) {
      var _this = this;

      var deferred = $q.defer();

      streamSearch.search('mechanics', typed).then(function (mechanics) {
        deferred.resolve(_this.list.concat(mechanics));
      });

      return deferred.promise;
    },
    format (mechanic) {
      return angular.isObject(mechanic) ? mechanic.display_name: mechanic;
    },
    choose (mechanic, row) {
      $scope.event.event_items_attributes[row.rowIndex].mechanic_id = mechanic.id;
      $scope.event.event_items_attributes[row.rowIndex].mechanic_display_name = mechanic.display_name;
    }
  };

  $scope.productSearch = {
    identifier: 'product_id',
    search (typed) {
      return productSearchApi.reservedStockSearch(typed);
    },
    /**
     * Instead of a stream search, there are
     * cases (barcode scan) where we just want
     * a quick find on the code without delaying
     * tab or anything. This is the call for that.
     * @param  {string} typed The entered value to search off of
     * @return {promise}         A promise related to the http call for product
     */
    quickSearch (typed) {
      return productSearchApi.quickSearch(typed);
    },
    format (product) {
      return angular.isObject(product) ? product.item_code: product;
    },
    getAdjustedCost (item, row) {
      productSearchApi.getAdjustedCost('event', $scope.customer, item)
      .then(price => {
        $scope.event.event_items_attributes[row.rowIndex].unit_price = price;
      });
    },
    getBomItems (item, row) {
      $scope.event.event_items_attributes[row.rowIndex].unit_price = 0;
      $scope.event.event_items_attributes[row.rowIndex].is_bom_parent = true;

      var params = [item.id, $scope.customer.id];

      productSearchApi.getBomItems('event', item, params)
      .then(boms => {
        Array.prototype.push.apply($scope.event.event_items_attributes, boms);

        $scope.addCalcFunctions();
      });
    },
    populate (item, row, isNewProduct) {
      productApi.getSalesTaxRate(item)
      .then(taxRate => {
        $scope.event.event_items_attributes[row.rowIndex].cost_including_tax = item.cost_including_tax;
        $scope.event.event_items_attributes[row.rowIndex].description        = item.description;
        $scope.event.event_items_attributes[row.rowIndex].flat_rate          = item.flat_rate;
        $scope.event.event_items_attributes[row.rowIndex].item_code          = item.item_code;
        $scope.event.event_items_attributes[row.rowIndex].product_id         = item.id;
        $scope.event.event_items_attributes[row.rowIndex].product_type       = item.product_type;
        $scope.event.event_items_attributes[row.rowIndex].repco_sku          = item.repco_product_sku;
        $scope.event.event_items_attributes[row.rowIndex].sales_tax_rate     = taxRate;
        $scope.event.event_items_attributes[row.rowIndex].unit_cost          = item.cost;

        if (isNewProduct) {
          $scope.event.event_items_attributes[row.rowIndex].quantity       = 1;
          $scope.event.event_items_attributes[row.rowIndex].unit_price     = item.retail_price;
          $scope.event.event_items_attributes[row.rowIndex].update_product = true;
        }
        else {
          $scope.event.event_items_attributes[row.rowIndex].gst_free      = item.gst_free;
          $scope.event.event_items_attributes[row.rowIndex].job_card_note = item.job_card_comment;
          $scope.event.event_items_attributes[row.rowIndex].note          = item.comment;
          $scope.event.event_items_attributes[row.rowIndex].ordering      = row.rowIndex * 1000000;

          if (item.product_type == 'J' && item.default_labour_quantity > 0){
            $scope.event.event_items_attributes[row.rowIndex].quantity = item.default_labour_quantity;
          }
          else {
            $scope.event.event_items_attributes[row.rowIndex].quantity = 1;
          }

          if (!$scope.Event.event.repco && item.repco_product_sku) {
            $scope.Event.event.repco = true;
          }

          if (!$scope.Event.event.ashdown && item.ashdown_ingram_product_sku) {
            $scope.Event.event.ashdown = true;
          }

          if (!$scope.Event.event.prolink && item.prolink_product_sku) {
            $scope.Event.event.prolink = true;
          }

          if (item.is_bom_parent) {
            this.getBomItems(item, row);
          }
          else if ($scope.customer.id) {
            this.getAdjustedCost(item, row);
          }
          else {
            $scope.event.event_items_attributes[row.rowIndex].unit_price = item.retail_price;
          }
        }

        $scope.setFlagsAndFunctions();
      });
    },
    choose (item, row) {
      const self = this;

      $q.when()
      .then(() => row.entity.id && row.entity.product_id !== item.id
        ? $scope.removeItem(row, true)
        : $q.when(true)
      )
      .then(() => {
        $scope.event.event_items_attributes[ row.rowIndex ].untouched = false;

        return item.last
          ? productSearchApi.advancedSearch({
              item_code   : item.item_code,
              product_type: 'S'
            }, row)
            .then(selection => {
              return { ...selection.selection, isNewProduct: selection.isNewProduct };
            })
          : $q.when(item);
      })
      .then(product => {
        self.populate(product, row, product.isNewProduct);
      });
    }
  };

  $scope.addItem = function () {
    $scope.event.event_items_attributes.push({
      id       : '',
      untouched: true
    });

    $scope.setFlagsAndFunctions();

    if (!$scope.$$phase) {
      $scope.$apply();
    }
  };

  $scope.addCustomerToVVGarage = function() {
    $scope.VVGarage.add_customer().then(() => {
      messages.show($translate.instant('VV_GARAGE_SPACE.CUSTOMER_ADDED_TO_VV_GARAGE'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.removeCustomerFromVVGarage = function() {
    $scope.VVGarage.delete_customer().then(() => {
      messages.show($translate.instant('VV_GARAGE_SPACE.CUSTOMER_REMOVED_FROM_VV_GARAGE'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.addItemFromRepco = function () {
    var origin = sessionObjAPI.base().origin;

    var getUrl = function (event) {
      if (event.vehicle_id) {
        return `${origin}workshop.html#/${event.customer_id}/${event.vehicle_id}/event/${event.id}`;
      }
      else {
        return `${origin}workshop.html#/${event.customer_id}/event/${event.id}`;
      }
    };

    var buildQuery = function (url, event) {
      var queryString = {
        hookUrl : url,
        type    : 'inquiry',
        event_id: event.id,
      };

      if ($scope.vehicle) {
        queryString.vehicleInfo = JSON.stringify($scope.vehicle);

        queryString['NEW_ITEM-CUST_FIELD6[1]']  = $scope.vehicle.make;
        queryString['NEW_ITEM-CUST_FIELD7[1]']  = $scope.vehicle.model;
        queryString['NEW_ITEM-CUST_FIELD22[1]'] = $scope.vehicle.plate_number;
        queryString['NEW_ITEM-CUST_FIELD23[1]'] = $scope.vehicle.plate_state;
      }

      queryString['HOOKURL'] = `${API.url}/events/add_item_from_repco/${event.id}`;

      return $.param(queryString);
    };

    confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.BOOKING_MUST_FIRST_BE_SAVED', { name: 'Repco' }), null, 'repcoEventAutoSave')
      .then(function () {
        return $scope.Event.save();
      }).then(function (event) {
        var url = getUrl(event);
        var queryString = buildQuery(url, event);

        $window.location.assign(`/repco.html?${queryString}`);
      }, function (err) {
        if (err) {
          messages.error(err);
        }
      });
  };

  $scope.addTemplates = function () {
    templatedWording.addTemplate('invoice').then(function (templates) {
      angular.forEach(templates, function (template) {
        if ($scope.event.note) {
          $scope.event.note = $scope.event.note + '\n\n' + template.wording;
        }
        else {
          $scope.event.note = template.wording;
        }
      });
    });
  };

  $scope.addJobCardTemplates = function () {
    templatedWording.addTemplate('job_card').then(function (templates) {
      angular.forEach(templates, function (template) {
        if ($scope.event.job_card_note) {
          $scope.event.job_card_note = $scope.event.job_card_note + '\n\n' + template.wording;
        }
        else {
          $scope.event.job_card_note = template.wording;
        }
      });
    });
  };

  $scope.removeItem = function ( row, replace = false ) {
    const deletedBoms = [];

    return $q.when()
      .then(() => {
        if ( row.entity.is_bom_parent ) {
          for ( let i = row.rowIndex + 1; i < $scope.event.event_items_attributes.length; ++i ) {
            const item = $scope.event.event_items_attributes[ i ];

            if ( item.is_bom_parent || !item.bom_parent_id ) {
              break;
            }
            else if ( item.bom_id === row.entity.bom_id ) {
              item._destroy = '1';

              deletedBoms.push($scope.event.event_items_attributes.splice(i--, 1)[ 0 ]);
            }
          }
        }

        const deletedItem = $scope.event.event_items_attributes.splice(row.rowIndex, 1);

        if ( $scope.event.id && row.entity.id ) {
          deletedItem[ 0 ]._destroy = '1';

          $scope.event.itemsToDelete = $scope.event.itemsToDelete.concat(deletedItem);
          $scope.event.itemsToDelete = $scope.event.itemsToDelete.concat(deletedBoms);
        }

        if ( replace ) {
          $scope.Event.replaceItem(deletedItem[ 0 ], row.rowIndex);
        }

        $scope.setFlagsAndFunctions();

        return $q.when();
      })
      .catch(err => {
        message.error(err);

        return $q.reject(false);
      });
  };

  $scope.getRowColor = function (item, column) {
    const classes = gridAPI.getColumnClasses(column);

    if ($scope.Event.closed()) {
      classes.push('readonly');
    }
    else if (item.is_bom_parent) {
      classes.push('bom-parent');
    }
    else if (item.bom_parent_id) {
      classes.push('bom-child');
    }

    return classes;
  };

  $scope.delete = function() {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.DELETE_EVENT', { num: $scope.event.event_number }))
      .then(function () {
        return workshopAPI.delete('/event', $scope.event.id);
      }).then(function () {
        $scope.Event.form.$setPristine();
        $state.go('app.transaction-center.bookings');
        messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.EVENT') , 'success');
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.updateEventTimes = function (row) {
    sessionObjAPI.setKey('event_time_row', row.rowIndex);

    $q.when()
    .then(() => row.entity.id ? $q.when() : confirm.generic($translate.instant('JS_SPACE.CONFIRM.SAVE_EVENT')))
    .then(() => row.entity.id ? $q.when() : $scope.submit())
    .then(() => $scope.event.id ? $scope.Event.showEventTimes(row.entity) : $q.when())
    .then(data => {
      if (data) {
        messages.show(data, 'success');
      }
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.submit = function (options) {
    return $scope.Event.save(options).then(function (event) {
      if (!options || !options.skipMessage) {
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.EVENT') , 'success');
      }

      return event;
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.changeEventTimeDate = function (oldDate, newDate, event_id, exists) {
    //message: would you like to change all bookings for old date to new date
    //get all the event time records
    //find the records for the old booking date
    //change this to the new booking date
    //send message saying it has been updated

    var old_date = $filter('date')(new Date(oldDate), $scope.dateFormat);
    var new_date = $filter('date')(new Date(newDate), $scope.dateFormat);
    if (exists == 'true') {
      workshopAPI.get('event_times/event_time_count_for_day_and_event', [oldDate, event_id]).then(function(count) {
        if (count > 0) {
          confirm.generic($translate.instant('JS_SPACE.MESSAGES.BOOKING_OLD_TO_NEW', {old: old_date, new: new_date}))
          .then(function () {
            var params = [oldDate, event_id, newDate];
            return workshopAPI.get('event_times/change_date_for_booking', params );
          }).then(function() {
            return $scope.submit({ skipMessage: true });
          }).then(function() {
            messages.show($translate.instant('JS_SPACE.MESSAGES.UPDATED.BOOKING_DATE_AND_TIMES'), 'success');
          }, function (err) {
            messages.error(err);
          });
        }
        else {
          $scope.submit({ skipMessage: true }).then(function() {
            messages.show($translate.instant('JS_SPACE.MESSAGES.UPDATED.BOOKING_DATE'), 'success');
          }, function (err) {
            messages.error(err);
          });
        };
      });

    }
    else {
      $scope.submit({ skipMessage: true }).then(function() {
        messages.show($translate.instant('JS_SPACE.MESSAGES.UPDATED.BOOKING_DATE'), 'success');
      }, function (err) {
        messages.error(err);
      });
    }
  };

  $scope.printBooking = function() {
    windowApi.open(`${ API.url }/reports/jasper_event_booking/${ $scope.event.id }.pdf`);
  };

  $scope.sendEmail = function () {
    messengerApi.email({
      customer_id  : customer.id,
      email_address: customer.email,
      name         : customer.display_name
    })
    .then(() => messages.show($translate.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success'));
  };

  $scope.sendSMS = function() {
    messengerApi.sms({
      customer_id: customer.id,
      name       : customer.display_name,
      send_to    : customer.mobile
    })
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success');
    });
  };

  $scope.startJob = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.SAVE_AND_START_JOB'))
      .then(function () {
        return $scope.Event.save();
      }).then(function (event) {
        return workshopAPI.get('events/event_to_invoice', event.id);
      }).then(function (invoice) {
        $state.go('app.invoice', {
            customer_id: invoice.customer_id,
            vehicle_id : invoice.vehicle_id,
            id         : invoice.invoice_id
        });
        messages.show($translate.instant('JS_SPACE.MESSAGES.CREATED.INVOICE') , 'success');
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.addItemsFromPartstech = function () {
    confirm.remember($translate.instant('PARTSTECH_SPACE.EVENT_ADD_PRODUCTS_MESSAGE'), null, 'partsTechEventAutoSave').then(() => {
      return $scope.Event.save();
    }).then(event => {
      return partstechApi.requestSession('event', event);
    }).then(url => {
      $window.location.assign(url);
    }).catch(err => {
      if (err) {
        messages.error(err);
      }
    });
  };

  $scope.initDiscount = function () {
    $scope.event.discount      = 0.00;
    $scope.event.discount_type = 'C';
  };

  $scope.isFlatRateEditable = function ( product ) {
    return !$scope.Event.closed()
      && product.product_id
      && !productApi.isBomParent(product)
      && productApi.isLabor(product);
  };

  $scope.$watch('event.tax_group_id', function (newId, oldId) {
    if ((newId !== oldId) && $scope.company.use_multi_tax) {
      $scope.filterTaxGroup(newId);
      $scope.calculateTotals();
    }
  });

  if (event) {
    $scope.prepInvoice();
  }
  else {
    $scope.addItem();
  }

  // if these params exist, user came
  // from booking diary to view a specific
  // unassigned event time.
  if ($stateParams.event_item_id && $stateParams.unassigned_event_time_id) {
    var index;

    for (var i=0; i<$scope.event.event_items_attributes.length; i++) {
      if ($scope.event.event_items_attributes[i].id === $stateParams.event_item_id) {
        index = i;
        i = $scope.event.event_items_attributes.length;
      }
    }

    $scope.Event.showEventTimes($scope.event.event_items_attributes[index], $stateParams.unassigned_event_time_id)
    .then(data => {
      messages.show(data, 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  }

  if (!$scope.event.id) {
    $scope.productSearch.populate(defaultLaborItem, { rowIndex: 0 }, false);
    $scope.event.event_items_attributes[0].untouched = false;
  }
  // cast to a string to account for a
  // possible index of 0.
  else if (index === sessionObjAPI.get('event_time_row')) {
    index = parseInt(index);

    if (index >= 0) {
      $scope.Event.showEventTimes($scope.event.event_items_attributes[index])
      .then(data => {
        messages.show(data, 'success');
      })
      .catch(err => {
        messages.error(err);
      })
      .finally(() => {
        sessionObjAPI.removeKey('event_time_row');
      });
    }
  }
  else {
    sessionObjAPI.removeKey('event_time_row');
  }

  $scope.$watch('event.event_items_attributes', function (items, oldItems) {
    if (!items || !items.length) {
      $scope.addItem();
    }
    if (items !== oldItems){
      $scope.calculateTotals();
    }
  }, true);

  $scope.$watch('event.event_date', function (newDate, oldDate) {
    if (event) {
      workshopAPI.get('/event/labour_line_exists', event.id).then(function(exists){
        if (newDate && oldDate && (oldDate !== newDate)) {
          $scope.changeEventTimeDate(oldDate, newDate, event.id, exists);
        };
      });
    }
    else {
      if (newDate && oldDate && (oldDate !== newDate)) {
        $scope.changeEventTimeDate(oldDate, newDate, event.id, false);
      };
    };

  }, true);
}